import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ButtonAction } from '../../component-button-action';
import { Close } from '../../component-icons';
import { forwardRef } from 'react';
/**
 * The `OverlayCardHeaderCloseButton` component is used to display the close button within the different `OverlayCard` header components.
 */
export const OverlayCardHeaderCloseButton = forwardRef((props, ref) => {
    return (_jsx(ButtonAction, { variant: "subtle", size: "md", icon: Close, ...props, ref: ref }));
});
OverlayCardHeaderCloseButton.displayName = 'OverlayCardHeaderCloseButton';
